import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { getChildUnitOf } from "../../../_helpers";

export function CalendarTimeUnit({
  unitName,
  dayCount,
  embedded = false,
  tooltipID,
}) {
  const { control } = useFormContext();
  if (unitName === "month") return null;
  const prefix = embedded ? "calendar." : "";
  // const unitDur = useWatch({ control, name: `time.${unitName}.duration` });
  const childName =
    unitName === "minute"
      ? "Seconds"
      : useWatch({
          control,
          name: `${prefix}time.${getChildUnitOf(unitName)}.plural`,
        });

  return (
    <div className="chronos-calendar-time-item">
      <div
        className="chronos-calendar-unit-duration"
        data-for={tooltipID}
        data-tip={
          unitName === "year"
            ? `The length of a year is calculated by your Calendar's "Months" settings`
            : ""
        }
      >
        {unitName === "year" ? (
          <input disabled value={dayCount} className="form-control" />
        ) : (
          <Controller
            control={control}
            name={`${prefix}time.${unitName}.duration`}
            id={`${prefix}time.${unitName}.duration`}
            as="input"
            className="form-control"
            disabled={unitName === "year" ? true : false}
          />
        )}
      </div>
      <div className="chronos-calendar-unit-info">
        <span className="chronos-bold">{childName}</span> in a
      </div>
      <div
        className="chronos-calendar-unit-name"
        data-for={tooltipID}
        data-tip={`This is equivalent to a real world ${unitName}`}
      >
        <Controller
          control={control}
          name={`${prefix}time.${unitName}.name`}
          id={`${prefix}time.${unitName}.name`}
          as="input"
          className="form-control"
          rules={{
            minLength: {
              value: 3,
              message: `The name of this unit should be at least 3 characters.`,
            },
          }}
        />
      </div>
      <div
        className="chronos-calendar-unit-plural"
        data-for={tooltipID}
        data-tip={`Plural for your equivalent to real world ${unitName}s`}
      >
        <Controller
          control={control}
          name={`${prefix}time.${unitName}.plural`}
          id={`${prefix}time.${unitName}.plural`}
          as="input"
          className="form-control"
          rules={{
            minLength: {
              value: 3,
              message: `The name of this unit should be at least 3 characters.`,
            },
          }}
        />
      </div>
    </div>
  );
}
